module.exports = __webpack_public_path__ + "img/art_mushimegane.8173d33c.png";